import React from "react";

const ExpandableRecord = () => {
  return <>Records list</>;
};

export default ExpandableRecord;
